/**
 * Carga lamejs desde public/voice/lame.min.js (evita bug MPEGMode del bundle npm+webpack).
 * La URL debe ser absoluta: los Workers creados con Blob no resuelven paths relativos.
 */

/**
 * @returns {string} URL absoluta a lame.min.js
 */
export function resolveLameScriptUrl() {
  let path = '/voice/lame.min.js'
  try {
    const base =
      (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || ''
    const prefix = String(base || '').replace(/\/+$/, '')
    path = `${prefix}/voice/lame.min.js`.replace(/\/{2,}/g, '/')
    if (!path.startsWith('/')) path = `/${path}`
  } catch (e) {
    path = '/voice/lame.min.js'
  }
  try {
    if (typeof window !== 'undefined' && window.location && window.location.href) {
      return new URL(path, window.location.href).href
    }
  } catch (e) {
    /* fall through */
  }
  return path
}

let _lamePromise = null

/**
 * @returns {Promise<*>}
 */
export function loadLamejs() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('lamejs solo en browser'))
  }
  if (window.lamejs && window.lamejs.Mp3Encoder) {
    return Promise.resolve(window.lamejs)
  }
  if (_lamePromise) return _lamePromise

  _lamePromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-udv-lamejs]')
    if (existing) {
      const wait = () => {
        if (window.lamejs && window.lamejs.Mp3Encoder) resolve(window.lamejs)
        else setTimeout(wait, 30)
      }
      wait()
      return
    }
    const s = document.createElement('script')
    s.src = resolveLameScriptUrl()
    s.async = true
    s.dataset.udvLamejs = '1'
    s.onload = () => {
      if (window.lamejs && window.lamejs.Mp3Encoder) resolve(window.lamejs)
      else reject(new Error('lamejs cargó sin Mp3Encoder'))
    }
    s.onerror = () => {
      _lamePromise = null
      reject(new Error('No se pudo cargar lame.min.js'))
    }
    document.head.appendChild(s)
  })

  return _lamePromise
}
